import React from 'react';
import * as calssnames from 'classnames';

import './styles.scss';

const Paragraph = ({text = '',firstText = '', isMarginTop,isList}) => {
	return (
		<p 
			className={
				calssnames('main-paragraph',{
					"main-paragraph--isMarginTop": isMarginTop,
					"main-paragraph--isList": isList,
				})
			}
		>
			{firstText && (
				<span className="main-paragraph__firstText">
					{firstText}
				</span>
			)}
			{text}
		</p>
	)
};

export default Paragraph;